export const RESPONSES = {
    YES: "yes",
    NO: "no"
}